module.exports = __webpack_public_path__ + "static/media/logo.faf59dc5.svg";